module.exports = __webpack_public_path__ + "img/CF_2V.cf194726.jpg";